import _ from 'lodash';
import type from '../../constants/notificationTypes';

// TODO: stop having this pre-filtered on a reducer and reimplement with memoized reducers

/**
 * Event notifications reducer
 */

export default function notificationsReducer(state, action) {
    if (!state) {
        state = {
            all: [],
            meetingInvite: [],
            meetingConfirmOrReject: [],
            newAnswer: [],
            silentUpdate: [],
            eventMessage: [],
            newChatMessage: [],
        };
    }

    switch (action.type) {
        case 'SESSION_UPDATES':
            state = notificationsReducer(state, app.actions.notifications.received(action.updates.notifications));
            break;
        case 'NOTIFICATIONS_RECEIVED':
            {
                let all = _([...action.notifications, ...state.all])
                    .uniqBy('id')
                    .value();
                state = Object.assign({}, state, {
                    all,
                    meetingInvite: _.filter(all, notif => _.get(notif, 'content.data.type') == type.MEETING_INVITE),
                    meetingConfirmOrReject: _.filter(all, notif => _.get(notif, 'content.data.type') == type.MEETING_CONFIRM_OR_REJECT),
                    newAnswer: _.filter(all, notif => _.get(notif, 'content.data.type') == type.NEW_ANSWER),
                    silentUpdate: _.filter(all, notif => _.get(notif, 'content.data.type') == type.SILENT_UPDATE),
                    eventMessage: _.filter(all, notif => _.get(notif, 'content.data.type') == type.EVENT_MESSAGE),
                    newChatMessage: _.filter(
                        all,
                        notif => _.get(notif, 'content.data.type') == type.NEW_CHAT_MESSAGE || _.get(notif, 'content.data.type') == type.CHAT_QUESTION
                    ),
                });
            }
            break;
    }

    return state;
}
